<div class="status">
  <ng-container *ngIf="!status; else SomeReason">
    <!-- for filter -->
    <ng-container *ngIf="isFilter; else NotFilter">
      <div class="reason">
        {{'project-connections.blank' | translate}}
      </div>
    </ng-container>
    <!-- for cell -->
    <ng-template #NotFilter>
      <div title="{{reason[verificationStatus.NOT_VERIFIED]}}">&nbsp;</div>
    </ng-template>
  </ng-container>

  <ng-template #SomeReason>
    <div class="status-content">
      <button
        *ngIf="showDiagnosisAction"
        type="button"
        class="diagnosis-action-button"
        [tooltip]="'project-connections.diagnosis.open' | translate"
        container="body"
        (click)="openDiagnosis($event)">
        <i class="fa fa-search" aria-hidden="true"></i>
      </button>
      <span class="status-label" [ngClass]="statusClass" title="{{reason[status]}}">
        <ng-container *ngIf="status === verificationStatus.VERIFIED">
          <i class="fa fa-check" aria-hidden="true"></i>
        </ng-container>
        <ng-container *ngIf="status === verificationStatus.PAYMENT_NOT_FOUND ||
                             status === verificationStatus.ERROR_DURING_VERIFICATION ||
                             status === verificationStatus.METER_READING_NOT_FOUND ||
                             status === verificationStatus.DATA_OUT_OF_DATE_RANGE ||
                             status === verificationStatus.DATA_NOT_FOUND ||
                             status === verificationStatus.PROGRAM_NOT_FOUND ||
                             status === verificationStatus.LAT_LONG_NOT_PROVIDED ||
                             status === verificationStatus.LAT_LONG_OUT_OF_RANGE ||
                             status === verificationStatus.NO_LOCATION_FOUND_FOR_LAT_LONG ||
                             status === verificationStatus.CONNECTION_DATE_OUT_OF_RANGE ||
                             status === verificationStatus.DEPARTMENT_MISSING ||
                             status === verificationStatus.STATE_MISSING ||
                             status === verificationStatus.VERIFICATION_RULE_NOT_FOUND">
          <i class="fa fa-question" aria-hidden="true"></i>
        </ng-container>
        <ng-container *ngIf="status === verificationStatus.VERIFICATION_ERROR ||
                             status === verificationStatus.NOT_VERIFIED ||
                             status === verificationStatus.DID_NOT_MEET_REQUIREMENTS">
          <i class="fa fa-times" aria-hidden="true"></i>
        </ng-container>
        <span class="reason">
          <ng-container *ngIf="status">
            {{reason[status]}}
          </ng-container>
        </span>
      </span>
    </div>
  </ng-template>
</div>
